// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.

export interface IPasswordComponent {

    // These are the vars needed for the CustomValidation.has3Categories() method.
    hasLowerCase: boolean;
    hasUpperCase: boolean;
    hasUnicode: boolean;
    hasNumber: boolean;
    hasSpecial: boolean;
    categoriesSatisfied: number;


    // These are the translation variables needed for the selection items
    tlMustHave1: string;
    tlMustHave2: string;
    tlMustHave3: string;
    tlMustHave4: string;
    tlUppercase: string;
    tlLowercase: string;
    tlLetter: string;
    tlUnicode: string;
    tlUnicode2: string;
    tlNumber: string;
    tlSpecialCharacter: string;
}

export class IPasswordComponentHelper {
    static specialCharacters = '!#$%*&()+-./:;<=>?@[\\]^_{}~\'"`';

    static addTranslationKeys(keyList: string[]) {
       keyList.push('PW_MUST_HAVE1', 'PW_MUST_HAVE2', 'PW_MUST_HAVE3', 'PW_MUST_HAVE4', 'SUB_UPPER', 'SUB_LOWER',
                    'SUB_LETTER', 'PW_UNICODE', 'PW_UNICODE2', 'SUB_NUMBER', 'SUB_SPECIAL');
    }

    static setTranslationValues(component: IPasswordComponent, translationValues) {
            component.tlMustHave1 = translationValues['PW_MUST_HAVE1'];
            component.tlMustHave2 = translationValues['PW_MUST_HAVE2'];
            component.tlMustHave3 = translationValues['PW_MUST_HAVE3'];
            component.tlMustHave4 = translationValues['PW_MUST_HAVE4'];
            component.tlUppercase = translationValues['SUB_UPPER'];
            component.tlLowercase = translationValues['SUB_LOWER'];
            component.tlLetter = translationValues['SUB_LETTER'];
            component.tlUnicode = translationValues['PW_UNICODE'];
            component.tlUnicode2 = translationValues['PW_UNICODE2'];
            component.tlNumber = translationValues['SUB_NUMBER'];
            component.tlSpecialCharacter = translationValues['SUB_SPECIAL'];
    }

    static showPasswordError(errorType, form) {
      switch (errorType) {
        case 'needsMoreCategories':
          if (!form.password.errors.required &&
              form.password.errors.needsMoreCategories) {
            return true;
          }
          break;
        case 'hasMinMaxlength':
            if (!form.password.errors.required &&
              !form.password.errors.needsMoreCategories &&
              (form.password.errors.minByteLength ||
              form.password.errors.maxByteLength)) {
            return true;
          }
          break;
      }
      return false;
  }

}

